import React, { useState } from "react";
import axios from "axios";
import {
    TextField,
    Button,
    Typography,
    Box,
    Alert,
    MenuItem,
    Stack,
} from "@mui/material";

const Register = () => {
    const [form, setForm] = useState({
        full_name: "",
        email: "",
        phone: "",
        gender: "",
        password: "",
    });
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
        setError(""); // Clear error on new input
        setMessage(""); // Clear success on new input
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setMessage("");
        try {
            await axios.post(`${API_BASE_URL}/users/register`, form);
            setMessage("Registration successful! Please login.");
        } catch (err) {
            if (err.response && err.response.data && err.response.data.detail) {
                setError(err.response.data.detail);
            } else {
                setError("Registration failed. Please try again.");
            }
        }
    };

    return (
        <Box
            maxWidth={450}
            mx="auto"
            mt={8}
            p={4}
            boxShadow={3}
            borderRadius={2}
            bgcolor="background.paper"
        >
            <Typography variant="h4" component="h1" mb={3} textAlign="center">
                Register
            </Typography>

            {message && (
                <Alert severity="success" sx={{ mb: 2 }}>
                    {message}
                </Alert>
            )}
            {error && (
                <Alert severity="error" sx={{ mb: 2, whiteSpace: "pre-wrap" }}>
                    {typeof error === "string" ? error : JSON.stringify(error)}
                </Alert>
            )}

            <form onSubmit={handleSubmit}>
                <Stack spacing={2}>
                    <TextField
                        label="Full Name"
                        name="full_name"
                        value={form.full_name}
                        onChange={handleChange}
                        required
                        fullWidth
                    />
                    <TextField
                        label="Email"
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleChange}
                        required
                        fullWidth
                    />
                    <TextField
                        label="Phone"
                        name="phone"
                        value={form.phone}
                        onChange={handleChange}
                        required
                        fullWidth
                    />
                    <TextField
                        select
                        label="Gender (optional)"
                        name="gender"
                        value={form.gender}
                        onChange={handleChange}
                        fullWidth
                    >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                    </TextField>
                    <TextField
                        label="Password"
                        type="password"
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        required
                        fullWidth
                    />
                    <Button variant="contained" type="submit" fullWidth>
                        Register
                    </Button>
                </Stack>
            </form>
        </Box>
    );
};

export default Register;
